import {
    API_ENDPOINT,
    API_VERSION,
    httpMethods,
    SUCCESS,
    clientErrorMessages,
    FAILURE,
    EMAIL_ALREADY_TAKEN,
} from "../../constants";
import { profileEmailMessages } from "../Profile/constants";
import { vsprintf } from "sprintf-js";
import { rootStore } from "../../redux/store";
import { setErrorState } from "../../redux/error_banner/actions";

export async function getUser(un, token) {
    return await fetch(
        vsprintf("%s/api/%s/user_accounts/user/%s", [
            API_ENDPOINT,
            API_VERSION,
            un,
        ]),
        {
            method: httpMethods.GET,
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            mode: "cors",
        }
    )
        .then((response) => response.json())
        .then((json) => {
            if (json.message === SUCCESS && json.payload.status === SUCCESS) {
                return json.payload;
            }

            throw new Error(clientErrorMessages.USER_UPDATE_FAILED);
        })
        .catch((e) => {
            rootStore.dispatch(setErrorState(true, String(e)));
            return null;
        });
}

export async function updateUser(un, token, profile) {
    return await fetch(
        vsprintf("%s/api/%s/user_accounts/user/%s", [
            API_ENDPOINT,
            API_VERSION,
            un,
        ]),
        {
            method: httpMethods.PUT,
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            mode: "cors",
            body: JSON.stringify({
                User: profile,
            }),
        }
    )
        .then((response) => response.json())
        .then((json) => {
            if (json.message === SUCCESS && json.payload.status === SUCCESS) {
                return json.payload;
            }
            if (
                json.message === FAILURE &&
                json.payload.status === EMAIL_ALREADY_TAKEN
            ) {
                rootStore.dispatch(
                    setErrorState(
                        true,
                        profileEmailMessages.EMAIL_ALREADY_TAKEN
                    )
                );
                return json.payload;
            }

            throw new Error(clientErrorMessages.USER_UPDATE_FAILED);
        })
        .catch((e) => {
            rootStore.dispatch(setErrorState(true, String(e)));
            return null;
        });
}
